import React, { memo, useCallback, useState } from 'react';
import { Card, cardTypes } from './Card';

import { IClientDemand } from 'types/demands';

import * as Styles from './styles';
import { isImage, isVideo } from 'utils/files';
import { Pagination } from 'components';
import { Flex } from '@chakra-ui/react';

interface IProps {
  files?: IClientDemand['solicitacaoDocumentos'];
  clientName?: string;
  date?: string;
}
// const items = [
//   {
//     id: '01',
//     data: '10/10/2021',
//     clientName: 'Marcos Santana',
//     filename: 'Teste de documento',
//     type: 'txt',
//     ext: 'pdf',
//   },
//   {
//     id: '02',
//     data: '10/01/2021',
//     clientName: 'MSantana',
//     filename: 'Teste 2 de documento',
//     type: 'pdf',
//     ext: 'pdf',
//   },
//   {
//     id: '03',
//     data: '03/01/2021',
//     clientName: 'M Santana',
//     filename: 'Teste 3 de documento',
//     type: 'pdf',
//     ext: 'pdf',
//   },
//   {
//     id: '04',
//     data: '03/01/2021',
//     clientName: 'M Santana',
//     filename: 'Teste 4 de documento',
//     type: 'pdf',
//     ext: 'pdf',
//   },
// ];
const DocumentsComponent: React.FC<IProps> = ({ files, clientName, date }) => {
  const size = 8;
  const [index, setIndex] = useState(1);
  const isType = useCallback((ext?: string) => {
    if (ext) {
      if (isVideo(ext)) {
        return cardTypes.video;
      } else if (isImage(ext)) {
        return cardTypes.image;
      }
    }
    return cardTypes.document;
  }, []);

  return (
    <Flex direction="column" alignItems="center">
      <Styles.Container>
        {files?.slice(index * size - size, index * size).map((i, k) => (
          <Card
            id={i.id}
            date={date}
            clientName={clientName}
            filename={i.filename}
            type={isType(i.ext)}
            key={k}
          />
        ))}
      </Styles.Container>
      <Pagination
        initialPage={index}
        pagesCount={Math.ceil(files ? files.length / size : 0)}
        onChange={setIndex}
      />
    </Flex>
  );
};

export const Documents = memo(DocumentsComponent);
